import React from "react";

export default function PaginationControls({ page, pageSize, totalItems, limit, total, onPageChange, alwaysShow = false }) {
  const safePageSize = Number(pageSize || limit || 20);
  const safeTotalItems = Number(totalItems ?? total ?? 0);
  const totalPages = Math.max(1, Math.ceil(safeTotalItems / safePageSize));
  if (!alwaysShow && safeTotalItems <= safePageSize) return null;

  const firstItem = safeTotalItems ? (page - 1) * safePageSize + 1 : 0;
  const lastItem = Math.min(page * safePageSize, safeTotalItems);

  return (
    <nav aria-label="Pagination" className="mt-4 flex flex-col gap-3 rounded-xl border border-slate-100 bg-white px-4 py-3 text-sm sm:flex-row sm:items-center sm:justify-between">
      <p className="text-slate-500">Showing {firstItem}–{lastItem} of {safeTotalItems}</p>
      <div className="flex items-center gap-2">
        <button type="button" disabled={page <= 1} onClick={() => onPageChange(page - 1)} className="rounded-lg border border-slate-200 px-3 py-1.5 font-semibold text-slate-600 disabled:cursor-not-allowed disabled:opacity-40">Previous</button>
        <span className="min-w-24 text-center font-semibold text-[#071C50]">Page {page} of {totalPages}</span>
        <button type="button" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)} className="rounded-lg border border-slate-200 px-3 py-1.5 font-semibold text-slate-600 disabled:cursor-not-allowed disabled:opacity-40">Next</button>
      </div>
    </nav>
  );
}
